<template>
  <div>
    <div class="page-header">
      <h2><span class="breadcrumb-level">系统管理</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level">系统配置</span><span class="breadcrumb-sep">/</span><span class="breadcrumb-level breadcrumb-current">TabBar设置</span></h2>
    </div>
    <el-form label-width="120px">
      <div v-for="item in list" :key="item.id" class="tab-item">
        <div class="tab-label">{{ item.text }}（{{ item.key }}）</div>
        <div class="tab-icons">
          <div class="icon-group">
            <div class="icon-label-text">未选中</div>
            <Upload v-model="item.icon_unselected_url" :max-count="1" tip="推荐尺寸 宽 81 × 高 81 px" />
          </div>
          <div class="icon-group">
            <div class="icon-label-text">选中</div>
            <Upload v-model="item.icon_selected_url" :max-count="1" tip="推荐尺寸 宽 81 × 高 81 px" />
          </div>
          <div class="icon-group">
            <div class="icon-label-text">文字</div>
            <el-input v-model="item.text" style="width:120px" />
          </div>
        </div>
      </div>
    </el-form>
    <div style="margin-top:20px">
      <el-button type="primary" @click="handleSave" :loading="saving">保存</el-button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { ElMessage } from 'element-plus';
import * as contentApi from '../../api/contentManagement';
import Upload from '../../components/Upload.vue';

const list = ref([]);
const saving = ref(false);

const fetchData = async () => {
  try {
    const res = await contentApi.getTabBarConfigs();
    list.value = (res.data || []).map(item => ({ ...item }));
  } catch { ElMessage.error('获取配置失败'); }
};

const handleSave = async () => {
  saving.value = true;
  try {
    for (const item of list.value) {
      await contentApi.updateTabBarConfig(item.id, {
        text: item.text,
        icon_selected_url: item.icon_selected_url,
        icon_unselected_url: item.icon_unselected_url,
      });
    }
    ElMessage.success('保存成功');
  } catch { ElMessage.error('保存失败'); }
  finally { saving.value = false; }
};

onMounted(fetchData);
</script>

<style scoped>
.tab-item { border: 1px solid #e0e0e0; border-radius: 12px; padding: 20px; margin-bottom: 16px; background: #fff; max-width: 600px; }
.tab-label { font-size: 15px; font-weight: 600; margin-bottom: 12px; color: #333; }
.tab-icons { display: flex; gap: 20px; align-items: flex-start; }
.icon-group { display: flex; flex-direction: column; align-items: center; gap: 6px; }
.icon-label-text { font-size: 12px; color: #999; }
</style>
